"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importDefault)(require("react"));
var prop_types_1 = (0, tslib_1.__importDefault)(require("prop-types"));
var lodash_1 = require("lodash");
var animate_1 = (0, tslib_1.__importDefault)(require("../../../../ui-components/animate/animate"));
var looped_slider_1 = (0, tslib_1.__importDefault)(require("../../../../ui-components/looped-slider/looped-slider"));
var button_1 = (0, tslib_1.__importDefault)(require("../../../../ui-components/nav/button/button"));
var inline_icon_1 = (0, tslib_1.__importDefault)(require("../../../../ui-components/inline-icon/inline-icon"));
var ArrowLeftIcon_1 = (0, tslib_1.__importDefault)(require("../../../../../icons/compiled/components/ArrowLeftIcon"));
var vertical_card_1 = (0, tslib_1.__importStar)(require("../vertical-card/vertical-card"));
// eslint-disable-next-line import/no-unresolved
var all_cards_scss_includeInitial_1 = (0, tslib_1.__importDefault)(require("./all-cards.scss?includeInitial"));
var withStyles_1 = require("../../../../../common/utils/withStyles");
var MAX_CARDS_PER_SLIDE = 6;
var VERTICAL_CARD_PADDING = 8;
var VIDEO_CARD_WIDTH_WITH_PADDING = vertical_card_1.VERTICAL_VIDEO_CARD_WIDTH + 2 * VERTICAL_CARD_PADDING;
var AllVideoCards = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(AllVideoCards, _super);
    function AllVideoCards(props) {
        var _this = _super.call(this, props) || this;
        _this.recalculateWidthAndSize = function () {
            var cardsData = _this.props.cardsData;
            var availableWidthForSlider = _this.contentRef.clientWidth;
            var cardsPerSlideCount = (0, lodash_1.clamp)(Math.min(Math.floor(availableWidthForSlider / VIDEO_CARD_WIDTH_WITH_PADDING), MAX_CARDS_PER_SLIDE), 0, cardsData.length);
            _this.setState({
                cardsPerSlideCount: cardsPerSlideCount,
                isNavVisible: cardsPerSlideCount !== cardsData.length,
            });
        };
        _this.renderItem = function (cardData) {
            var _a = _this.props, onCardClick = _a.onCardClick, labels = _a.labels;
            return (react_1.default.createElement(vertical_card_1.default, { key: cardData.clientId, labels: labels, cardData: cardData, className: all_cards_scss_includeInitial_1.default.item, onCardClick: onCardClick }));
        };
        _this.saveContentRef = function (ref) {
            _this.contentRef = ref;
        };
        _this.renderPrevButton = function (_a) {
            var onClick = _a.onClick;
            return (_this.state.isNavVisible && (react_1.default.createElement(button_1.default, { className: all_cards_scss_includeInitial_1.default.prev, ariaLabel: _this.props.prevButtonAriaLabel, arrowIcon: react_1.default.createElement(inline_icon_1.default, { icon: react_1.default.createElement(ArrowLeftIcon_1.default, { size: null }) }), tabIndex: 0, dataHook: "prev-button", onClick: onClick })));
        };
        _this.renderNextButton = function (_a) {
            var onClick = _a.onClick;
            return (_this.state.isNavVisible && (react_1.default.createElement(button_1.default, { className: all_cards_scss_includeInitial_1.default.next, ariaLabel: _this.props.nextButtonAriaLabel, tabIndex: 0, arrowIcon: react_1.default.createElement(inline_icon_1.default, { icon: react_1.default.createElement(ArrowLeftIcon_1.default, { size: null }) }), dataHook: "next-button", onClick: onClick })));
        };
        _this.stopPropagation = function (event) {
            event.stopPropagation();
        };
        _this.contentRef = null;
        _this.state = {
            cardsPerSlideCount: null,
            isNavVisible: false,
        };
        return _this;
    }
    AllVideoCards.prototype.componentDidMount = function () {
        this.recalculateWidthAndSize();
        this.recalculateWidthAndSize = (0, lodash_1.debounce)(this.recalculateWidthAndSize);
        window.addEventListener('resize', this.recalculateWidthAndSize);
    };
    AllVideoCards.prototype.componentDidUpdate = function (_a) {
        var cardsData = _a.cardsData;
        if (cardsData.length === this.props.cardsData.length) {
            return;
        }
        if (this.contentRef) {
            this.recalculateWidthAndSize();
        }
    };
    AllVideoCards.prototype.componentWillUnmount = function () {
        window.removeEventListener('resize', this.recalculateWidthAndSize);
    };
    AllVideoCards.prototype.render = function () {
        var _a = this.props, cardsData = _a.cardsData, getSlideAriaLabel = _a.getSlideAriaLabel;
        var cardsPerSlideCount = this.state.cardsPerSlideCount;
        return (react_1.default.createElement("div", { className: all_cards_scss_includeInitial_1.default.container, "data-hook": "all-cards" },
            react_1.default.createElement("div", { className: all_cards_scss_includeInitial_1.default.content, ref: this.saveContentRef },
                react_1.default.createElement(animate_1.default, { className: all_cards_scss_includeInitial_1.default.animate, when: cardsPerSlideCount > 0 }, cardsPerSlideCount && (react_1.default.createElement("div", { className: all_cards_scss_includeInitial_1.default.slider, onClick: this.stopPropagation },
                    react_1.default.createElement(looped_slider_1.default, { width: VIDEO_CARD_WIDTH_WITH_PADDING * cardsPerSlideCount, renderNextButton: this.renderNextButton, renderPrevButton: this.renderPrevButton, getSlideAriaLabel: getSlideAriaLabel, itemWidth: VIDEO_CARD_WIDTH_WITH_PADDING }, (0, lodash_1.map)(cardsData, this.renderItem))))))));
    };
    AllVideoCards.propTypes = {
        cardsData: prop_types_1.default.array,
        onCardClick: prop_types_1.default.func,
        getSlideAriaLabel: prop_types_1.default.func,
        prevButtonAriaLabel: prop_types_1.default.string,
        nextButtonAriaLabel: prop_types_1.default.string,
        labels: prop_types_1.default.object,
    };
    AllVideoCards.defaultProps = {
        getSlideAriaLabel: (0, lodash_1.constant)(''),
    };
    AllVideoCards = (0, tslib_1.__decorate)([
        (0, withStyles_1.withStyles)(all_cards_scss_includeInitial_1.default)
    ], AllVideoCards);
    return AllVideoCards;
}(react_1.default.Component));
exports.default = AllVideoCards;
//# sourceMappingURL=all-cards.js.map